<template>
    <div class="mb-2 col-sm-4 col-md-4 col-lg-3">
        <div class="text-left" :class="[buttonAlignmentClass]">
            <div class="btn-group">
                <button type="button" class="lead color-black btn btn-sm btn-outline-dark">{{ item.title }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['buttonAlignment','item','index','itemKey'],
        data () {
            return {};
        },
        methods: {
        },
        computed: {
            buttonAlignmentClass: function(){
                return {
                    "text-md-left": this.buttonAlignment != "center" ? true : false,
                    "text-md-center": this.buttonAlignment == "center" ? true : false
                };
            }
        }
    }
</script>
